import { useMemo } from 'react'
import { Button, SelectMultiple } from '~/components/ui'

type ZipCodeFilterProps = {
  zipCodeValues: string[]
  filterZipCode: string[]
  updateFilter: (key: string, value: any) => void
}

export default function ZipCodeFilter({
  zipCodeValues,
  filterZipCode,
  updateFilter,
}: ZipCodeFilterProps) {
  const zipCodeData = useMemo(
    () =>
      zipCodeValues.map((zone) => {
        const abbr = zone.split(' ')[0]
        return { label: abbr, value: abbr }
      }),
    [zipCodeValues]
  )

  return (
    <div className="space-y-2">
      <p className="text-sm">
        Zip Code
        {filterZipCode.length > 0 && (
          <Button
            variant="link"
            size="none"
            className="ml-2"
            onClick={() => updateFilter('zipCodes', undefined)}>
            (reset)
          </Button>
        )}
      </p>
      <SelectMultiple
        scrollIntoView
        placeholder="Search zip codes to filter..."
        options={zipCodeData}
        selected={filterZipCode.map((v) => ({ label: v, value: v }))}
        setSelected={(selected) => {
          updateFilter(
            'zipCodes',
            selected.map(({ value }) => value)
          )
        }}
      />
    </div>
  )
}
